module.exports = __webpack_public_path__ + "img/file-zip.c4555692.svg";